import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

import { FsAutocompleteChipsModule } from '@firestitch/autocomplete-chips';
import { FsBadgeModule } from '@firestitch/badge';
import { FsDialogModule } from '@firestitch/dialog';
import { FsFormModule } from '@firestitch/form';
import { FsSkeletonModule } from '@firestitch/skeleton';

import { DonateComponent } from './components';
import { DonateService } from './services';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MatDialogModule,
        MatFormFieldModule,
        MatButtonModule,
        FsDialogModule,
        FsFormModule,
        FsSkeletonModule,
        FsAutocompleteChipsModule,
        FsBadgeModule,
        DonateComponent,
    ],
    exports: [
        DonateComponent,
    ],
    providers: [
        DonateService,
    ],
})
export class DonateModule { }
